export default __webpack_public_path__ + "static/prometheus_grafana-c810a7fce5d08ce8b250a2e855f2c96d.jpeg";